export default "__VITE_ASSET__badc7614__"